// import TemplateSummariesView from "./TemplateSummariesView";
import TemplateConfigurationViewV2 from "./TemplateConfigurationViewV2";
import TemplateQueryingViewV2 from "./TemplateQueryingViewV2";
import VisualizationSummariesView from "./VisualizationSummariesView";
import VisualizationEditingView from "./VisualizationEditingView";
import IndexSubscriptionView from "./IndexSubscription";

import auth from "../Service/AuthFetchService";

import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import React from "react";
import { Tabs } from "antd";
import { AppstoreOutlined } from "@ant-design/icons";
import isEmpty from "lodash/isEmpty";
import {
  BarChartOutlined,
  // SearchOutlined,
  BookOutlined,
  // AppstoreAddOutlined,
} from "@ant-design/icons";
import IndexSubscriptionEdit from "./IndexSubscription/IndexSubscriptionEdit";
import TemplateListView from "./TemplateListView";
// import IndicatorExtraction from "./IndicatorExtraction";
// import ExtractionView from "./ExtractionView";

class QueryingGuideView extends React.Component {
  pathToView = {
    "/querying_guide/template": "GuideTemplate",
    "/querying_guide/template/guide": "GuideTemplate",
    "/querying_guide/using": "GuideWork",
  };

  constructor() {
    super();
    const path = window.location.pathname;
    let view = this.pathToView[path];
    if (view === undefined) {
      if (path.match("^/querying_guide/template/\\d+/detail$")) {
        view = "GuideTemplate";
      }
      if (path.match("^/querying_guide/template/\\d+/using$")) {
        view = "GuideWork";
      }
    }

    // const query = parseUrlSearch(window.location.search);
    // console.log(query);
    const tab = localStorage.getItem("queryGuide.active.tab");
    const viewType = localStorage.getItem("queryGuide.active.viewType");
    this.state = {
      collapsed: false,
      currentView: view === undefined ? "GuideWork" : view,
      activeTab: isEmpty(tab) ? "Template" : tab,
      viewType: isEmpty(viewType) ? "list" : viewType,
    };
  }

  collapseSider() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  render() {
    return (
      <>
        <Router basename="/querying_guide">
          <Route
            path="/dashboard"
            exact
            render={() => (
              <Tabs
                style={{ margin: "10px 40px 10px 40px" }}
                activeKey={this.state.activeTab}
                onChange={(activeTab) => {
                  this.setState({ activeTab });
                  localStorage.setItem("queryGuide.active.tab", activeTab);
                }}
              >
                {/* {(auth.allow("datap:querying_guide:template") ||
                  auth.allow("datap:querying_guide:work")) && (
                  <Tabs.TabPane
                    key="Template"
                    tab={
                      <div>
                        <AppstoreOutlined />
                        指标查询
                      </div>
                    }
                  >
                    <TemplateSummariesView />
                  </Tabs.TabPane>
                )} */}
                {(auth.allow("datap:querying_guide:template") ||
                  auth.allow("datap:querying_guide:work")) && (
                  <Tabs.TabPane
                    key="Template"
                    tab={
                      <div>
                        <AppstoreOutlined />
                        指标查询
                      </div>
                    }
                  >
                    <TemplateListView />
                  </Tabs.TabPane>
                )}
                {/* {auth.allow("datap:querying_cube:cube_query") && (
                  <Tabs.TabPane
                    key="ExtractionView"
                    tab={
                      <div>
                        <SearchOutlined />
                        指标提取
                      </div>
                    }
                  >
                    <ExtractionView />
                  </Tabs.TabPane>
                )} */}

                {auth.allow("datap:querying_guide:visualization") && (
                  <Tabs.TabPane
                    key="Visualization"
                    tab={
                      <div>
                        <BarChartOutlined />
                        可视化
                      </div>
                    }
                  >
                    <VisualizationSummariesView />
                  </Tabs.TabPane>
                )}
                {auth.allow("datap:querying_indicator:indicator_report") && (
                  <Tabs.TabPane
                    key="IndexSubscription"
                    tab={
                      <div>
                        <BookOutlined />
                        数据订阅
                      </div>
                    }
                  >
                    <IndexSubscriptionView />
                  </Tabs.TabPane>
                )}
                {/* {(auth.allow("datap:querying_cube:dim_manger") ||
                  auth.allow("datap:querying_cube:metric_manger") ||
                  auth.allow("datap:querying_cube:cube_manger")) && (
                  <Tabs.TabPane
                    key="IndicatorManage"
                    tab={
                      <div>
                        <AppstoreAddOutlined />
                        指标数据管理
                      </div>
                    }
                  >
                    <IndicatorExtraction />
                  </Tabs.TabPane>
                )} */}
              </Tabs>
            )}
          />
          {auth.allow("datap:querying_guide:visualization") && (
            <Route
              path="/visualization/:id/edit"
              exact
              render={(history) => (
                <VisualizationEditingView vid={history.match.params.id} />
              )}
            />
          )}
          {auth.allow("datap:querying_guide:template") && (
            <Route
              path="/template/guide"
              exact
              render={() => (
                <div style={{ margin: "10px 40px 10px 40px" }}>
                  <TemplateConfigurationViewV2 />
                </div>
              )}
            />
          )}
          {(auth.allow("datap:querying_guide:template") ||
            auth.allow("datap:querying_guide:work")) && (
            <Route
              path="/template/:id/using"
              exact
              render={(history) => (
                <div style={{ margin: "10px 40px 10px 40px" }}>
                  <TemplateQueryingViewV2
                    tmplId={history.match.params.id}
                    rowsOffset={220}
                    editing={false}
                  />
                </div>
              )}
            />
          )}
          {auth.allow("datap:querying_guide:template") && (
            <Route
              path="/template/:id/detail"
              exact
              render={(history) => (
                <div style={{ margin: "10px 40px 10px 40px" }}>
                  <TemplateConfigurationViewV2
                    tmplId={history.match.params.id}
                  />
                </div>
              )}
            />
          )}
          {/* 新建指标订阅 */}
          {auth.allow("datap:querying_indicator:indicator_report") && (
            <Route
              path="/subscription/create"
              exact
              render={() => (
                <div style={{ margin: "10px 40px 10px 40px" }}>
                  <IndexSubscriptionEdit />
                </div>
              )}
            />
          )}
          {/* 编辑指标订阅 */}
          {auth.allow("datap:querying_indicator:indicator_report") && (
            <Route
              path="/subscription/edit/:id"
              exact
              render={(history) => (
                <div style={{ margin: "10px 40px 10px 40px" }}>
                  <IndexSubscriptionEdit id={history.match.params.id} />
                </div>
              )}
            />
          )}
          <Route
            path="/"
            exact
            render={() => <Redirect to="/dashboard" />}
          ></Route>
        </Router>
      </>
    );
  }
}

export default QueryingGuideView;
